import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TinymceModule } from 'angular4-tinymce-biznet';

import { CustomMaterialModule } from '../custom-material/custom-material.module';
import { MainModule } from '../main/main.module';

import { AuditListComponent } from './audit-list/audit-list.component';
import { ReportComponent } from './report/report.component';

import { environment } from '../../environments/environment';
import { PdfDialogComponent } from './pdf-dialog/pdf-dialog.component';
import { QuestionnaryComponent } from './questionnary/questionnary.component';
import { BackDialogComponent } from './back-dialog/back-dialog.component';
import { GlobalDataProvider } from '../main/Models/global.model.provider';
import { IndicatorComponent } from './indicator/indicator.component';
import { TranslocoRootModule } from '../transloco/transloco-root.module';

let tinymceBaseUrl = window['__env'].baseUrl+'/miiar/assets/tinymce/';



@NgModule({
  id: 'auditmodule',
  imports: [
    CommonModule, FormsModule,
    CustomMaterialModule,
    MainModule,
    TranslocoRootModule,
    TinymceModule.withConfig({
        language: 'fr_FR',
        height: 600,
        theme: 'modern',
        skin_url: tinymceBaseUrl+'skins/lightgray',
        external_plugins: {
          image: tinymceBaseUrl+'plugins/image/plugin.js',
          imagetools: tinymceBaseUrl+'plugins/imagetools/plugin.js',
          textcolor: tinymceBaseUrl+'plugins/textcolor/plugin.js',
          colorpicker: tinymceBaseUrl+'plugins/colorpicker/plugin.js',
          table: tinymceBaseUrl+'plugins/table/plugin.js',
          pagebreak: tinymceBaseUrl+'/plugins/pagebreak/plugin.js',
          lists: tinymceBaseUrl+'/plugins/lists/plugin.min.js',
          code: tinymceBaseUrl+'/plugins/code/plugin.js',
          fullscreen: tinymceBaseUrl+'/plugins/fullscreen/plugin.js',
          //paste: tinymceBaseUrl+'/plugins/paste/plugin.min.js',
          //poodll: tinymceBaseUrl+'/plugins/poodll/poodll.js',
        },
        toolbar: 'undo redo | styleselect | bold italic | numlist bullist | alignleft aligncenter alignright alignjustify | link  image imagetools | forecolor backcolor table',
        images_upload_handler: function (blobInfo, success, failure) {
          success('data:image/png;base64,'+blobInfo.base64());
        }
      })
  ],
  declarations: [
    QuestionnaryComponent,
    IndicatorComponent,
    ReportComponent,
    AuditListComponent,
    PdfDialogComponent,
    BackDialogComponent,
  ],
  exports: [
    ReportComponent,
    AuditListComponent
  ],
  entryComponents: [
    PdfDialogComponent,
    BackDialogComponent
  ],
  providers: [GlobalDataProvider]
})
export class AuditModule { }
